import { doc } from 'rxfire/firestore'
import { map } from 'rxjs/operators'
import { assoc } from 'ramda'
import { connection } from 'Services/user'

export function getProfessional(professionalId) {
  return doc(connection.firestore().collection('professionals').doc(professionalId))
    .pipe(map(doc => assoc('uid', doc.id, doc.data())))
}
